import { render, staticRenderFns } from "./ApplicationsCell.vue?vue&type=template&id=1673dd6c&scoped=true"
import script from "./ApplicationsCell.vue?vue&type=script&lang=js"
export * from "./ApplicationsCell.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsCell.vue?vue&type=style&index=0&id=1673dd6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673dd6c",
  null
  
)

export default component.exports